export const changeAuth = (login,token)=>async (dispatch)=>{
    dispatch({
        type:"LOGIN",
        payload:{login:login,token:token},
    })
 
 }